export default __webpack_public_path__ + "static/media/3_1.410283bd.png";